import type { HTTPHeaders } from "@simbelapp/order-sdk";

/** orders reads it at sign-in and stores it on the user when it differs, except under a Log As. */
export const TIMEZONE_HEADER = "X-Timezone";

/** The raw zone, not `getBrowserTimezone()`: its Paris fallback would overwrite a correct stored zone. */
export function detectedTimezone(): string | null {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
}

export function withTimezoneHeader(headers: HTTPHeaders = {}): HTTPHeaders {
  const timezone = detectedTimezone();
  return timezone ? { ...headers, [TIMEZONE_HEADER]: timezone } : headers;
}
